<template>
  <div class="warningRequiredFields">
    <v-alert class="col-md-12 mandatory-data">
      <span>*</span> Campo Obrigatório
    </v-alert>
  </div>
</template>


<script>
export default {
  name: "WarningRequiredFields",
};
</script>
<style>
.warningRequiredFields .mandatory-data {
  font-size: 12px;
  color: #f00;
  padding: 2px 0px 0px 0px !important;
}
</style>